import Utils from '@/utils'
import { API } from '@/models/core'
import { User } from '@/models/user'
import { FantasyContest } from '@/models/fantasy'
import { MatchMeta, TeamMeta } from '@/models/fantasy'
import { FantasyUserTeam } from '@/models/fantasy'

export class GameReward {
  static createFromJson (raw) {
    let obj = new GameReward()
    obj = Object.assign(obj, raw)
    return obj
  }
}

export class GameParticipant {
  static createFromJson (raw) {
    let obj = new GameParticipant()
    obj = Object.assign(obj, raw)
    obj.teamUpdatedAt = Utils.utcToLocalTimeConversion(raw.team_updated_at)
    obj.user = User.createFromJson(raw.user)
    obj.reward = GameReward.createFromJson(raw.reward)
    return obj
  }
}

export class UserTeam {
  static createFromJson (raw) {
    let obj = new UserTeam()
    obj = Object.assign(obj, raw)
    obj.updated = Utils.utcToLocalTimeConversion(raw.updated)
    return obj
  }
}

export class Contest {
  static createFromJson (raw) {
    let obj = new Contest()
    obj = Object.assign(obj, raw)
    return obj
  }

  static detail (key) {
    let params = {}
    return API.instance().get(`/fantasy-game/${API.faKey}/contest/${key}/detail/`, params).then((resp) => {
      const detail = FantasyContest.createFromJson(resp.data.data)
      return detail
    })
  }

  static games (key, cursor) {
    let params = {}
    let url
    if (cursor) {
      url = `/fantasy-game/${API.faKey}/contest/${key}/games/?last=${cursor.last}&&lastkey=${cursor.lastkey}&&total=${cursor.total}`
    } else {
      url = `/fantasy-game/${API.faKey}/contest/${key}/games/`
    }
    return API.instance().get(url, params).then((resp) => {
      const data = resp.data.data
      const cursor = data.cursor
      const total = data.total
      const previews = data.previews.map(x => GamePreview.createFromJson(x))
      return { cursor, previews, total }
    })
  }
}

export class GamePlayerInfo {
  static createFromJson (raw) {
    let obj = new GamePlayerInfo()
    obj = Object.assign(obj, raw)
    return obj
  }
}

export class GamePlayerCredits extends GamePlayerInfo {}
export class GamePlayerPoints extends GamePlayerInfo {}

export class GameCreditsPoints {
  static parsePlayers (raw) {
    return raw.players
  }

  static createFromJson (raw) {
    let obj = new GameCredits()
    obj = Object.assign(obj, raw)

    obj.matches = {}
    Object.keys(raw.matches).forEach((key) => {
      obj.matches[key] = MatchMeta.createFromJson(raw.matches[key])
    })

    obj.teams = {}
    Object.keys(raw.teams).forEach((key) => {
      obj.teams[key] = TeamMeta.createFromJson(raw.teams[key])
    })

    obj.players = this.parsePlayers(raw)
    return obj
  }
}

export class GameCredits extends GameCreditsPoints {
  static parsePlayers (raw) {
    let players = {}
    Object.keys(raw.players).forEach((key) => {
      players[key] = GamePlayerCredits.createFromJson(raw.players[key])
    })

    return players
  }
}

export class GamePoints extends GameCreditsPoints {
  static parsePlayers (raw) {
    let players = {}
    Object.keys(raw.players).forEach((key) => {
      players[key] = GamePlayerPoints.createFromJson(raw.players[key])
    })

    return players
  }

  static fetch (gameKey) {
    let params = {}
    return API.instance().get(`/fantasy-game/${API.faKey}/game/${gameKey}/points/`, params).then((resp) => {
      const points = GamePoints.createFromJson(resp.data.data)
      return points
    })
  }
}

export class GameTeam {
  static createFromJson (raw) {
    let obj = new GameTeam()
    obj = Object.assign(obj, raw)
    obj.team = UserTeam.createFromJson(raw.team)
    obj.points.updated = Utils.getMomentDate(raw.points.match_updated_ts)
    obj.points.updated = Utils.utcToLocalTimeConversion(obj.points.updated)
    return obj
  }
  static fetch (gameKey, teamKey) {
    let params = {}
    return API.instance().get(`/fantasy-game/${API.faKey}/game/${gameKey}/team/${teamKey}/`, params).then((resp) => {
      const team = GameTeam.createFromJson(resp.data.data)
      return team
    })
  }
}

export class GameTeams {
  static getAllGameteams (gameKey) {
    const params = {}
    return API.instance().get(`/fantasy-game/${API.faKey}/game/${gameKey}/user-teams/`, params).then((resp) => {
      const teams =  resp.data.data
      return teams
    })
  }

  static getGameTeam (gameKey, teamKey) {
    const params = {}
    return API.instance().get(`/fantasy-game/${API.faKey}/game/${gameKey}/team/${teamKey}/`, params).then((resp) => {
      const teams =  resp.data.data
      if (teams.team) {
        teams.team = UserTeam.createFromJson(teams.team)
      }
      return teams
    })
  }
}

export class GameMatch {
  static createFromJson (raw) {
    let obj = new GameMatch()
    obj = Object.assign(obj, raw)
    obj.match = MatchMeta.createFromJson(raw.match)
    obj.closesAt = Utils.getMomentDate(raw.closes_at)
    return obj
  }
}

export class GamePreview {
  get allParticipants () {
    let participants = []
    let added = {}
    let position = 1
    // top_participants
    // nearest_participants

    this.top_participants.forEach((item) => {
      participants.push(item)
      added[item.user.key] = true
    })

    if (participants.length > 0 && this.nearest_participants.length > 0) {
      participants.push({ isBreak: true, position })
      position++
    }

    this.nearest_participants.forEach((item) => {
      participants.push(item)
      added[item.user.key] = true
    })

    if (this.my_participation && (!added[this.my_participation.user.key])) {
      const item = this.my_participation
      participants.push({ isBreak: true, position })
      participants.push(item)
      added[item.user.key] = true
    }

    if (this.total_participants > participants.length) {
      participants.push({ isBreak: true, position })
    }

    return participants
  }

  loadMoreParticipants () {
    let params = this.top_cursor
    return API.instance().get(`/fantasy-game/${API.faKey}/game/${this.game.key}/paricipants/`, { params }).then((resp) => {
      const page = GameParticipantsPage.createFromJson(resp.data.data)
      this.top_participants.push(...page.participants)
      this.top_cursor = page.cursor
      // this.total_participants = this.total_participants
    })
  }

  fetchContest () {
    let params = {}
    return API.instance().get(`/fantasy-game/${API.faKey}/contest/${this.contest.key}/detail/`, params).then((resp) => {
      const detail = FantasyContest.createFromJson(resp.data.data)
      return detail
    })
  }

  fetchCredits () {
    let params = {}
    return API.instance().get(`/fantasy-game/${API.faKey}/game/${this.game.key}/credits/`, params).then((resp) => {
      const credits = GameCredits.createFromJson(resp.data.data)
      return credits
    })
  }

  static createFromJson (raw) {
    let obj = new GamePreview()

    obj = Object.assign(obj, raw)
    obj.game = FantasyGame.createFromJson(raw.game)
    obj.matches = raw.matches.map(x => GameMatch.createFromJson(x))

    if (raw.my_team) {
      obj.my_team = UserTeam.createFromJson(raw.my_team)
    }

    if (raw.my_participation) {
      obj.my_participation = GameParticipant.createFromJson(raw.my_participation)
    }

    obj.top_participants = raw.top_participants.map(x => GameParticipant.createFromJson(x))
    obj.nearest_participants = raw.nearest_participants.map(x => GameParticipant.createFromJson(x))

    return obj
  }

  static fetch (key) {
    let params = {}
    return API.instance().get(`/fantasy-game/${API.faKey}/game/${key}/preview/`, params).then((resp) => {
      return GamePreview.createFromJson(resp.data.data)
    })
  }
}

export class ContestLeaderbord {
  constructor (contestKey) {
    this.contestKey = contestKey
    this.items = []
    this.cursor = null
    this.total = null
    this.pageSize = -1
    this.hasMorePage = true
  }

  page () {
    let params = this.cursor
    return API.instance().get(`/fantasy-game/${API.faKey}/contest/${this.contestKey}/leaderboard/`, { params }).then((resp) => {
      const raw = resp.data.data
      this.items.push(...raw.leaderboard)
      this.hasMorePage = (this.cursor !== raw.cursor)
      this.cursor = raw.cursor
      this.total = raw.total
      this.pageSize += 1
      return this
    })
  }
  getUserGroupLeaderboard (key) {
    let params = this.cursor
    return API.instance().get(`/fantasy-game/${API.faKey}/contest/${key}/user-group-leaderboard/`, { params }).then((resp) => {
      const raw = resp.data.data
      Object.keys(raw.leaderboard).forEach((key) => {
        FantasyGroup.fetch(raw.leaderboard[key].group.key)
        .then(response => {
          raw.leaderboard[key].group = response
        }).catch((error) => {
          console.log(error)
        })
      })
      this.items.push(...raw.leaderboard)
      this.hasMorePage = (this.cursor !== raw.cursor)
      this.cursor = raw.cursor
      this.total = raw.total
      this.pageSize += 1
      return this
    })
  }
}

export class FantasyGroup {
  constructor () {
    this.key = null
    this.name = null
    this.image = null
    this.moto = null
  }
  static fetch (key) {
    return API.instance().get(`/fantasy-app/${API.faKey}/fantasy-group/?key=${key}`).then((resp) => {
      return FantasyGroup.createFromJson(resp.data.data.fantasy_group)
    })
  }
  
  static createFromJson (raw) {
    let obj = new FantasyGroup()
    obj = Object.assign(obj, raw)
    obj.createdAt = Utils.utcToLocalTimeConversion(raw.created_at)
    return obj
  }
}

export class GameParticipantsPage {
  static createFromJson (raw) {
    let obj = new GameParticipantsPage()

    obj = Object.assign(obj, raw)
    obj.participants = raw.game_preview.participants.map(x => GameParticipant.createFromJson(x))

    return obj
  }
}

export class FantasyGame {
  static createFromJson (raw) {
    let obj = new FantasyGame()
    obj = Object.assign(obj, raw)
    obj.closesAt = Utils.utcToLocalTimeConversion(raw.first_match_closes_at)
    return obj
  }
}

export class UserHome {
  static fetch () {
    let params = {}
    return API.instance().get(`/fantasy-game/${API.faKey}/user-home/`, params).then((resp) => {
      return UserHome.createFromJson(resp.data.data)
    })
  }

  static createFromJson (raw) {
    let home = new UserHome()
    home = Object.assign(home, raw)

    home.games = {}
    Object.keys(raw.games).forEach((key) => {
      home.games[key] = FantasyGame.createFromJson(raw.games[key])
    })

    home.contests = {}
    Object.keys(raw.contests).forEach((key) => {
      home.contests[key] = Contest.createFromJson(raw.contests[key])
    })
    return home
  }
}
